import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const AboutLazy = lazyLoader(
  () => import('./About' /* webpackChunkName: "about" */),
);

const About = () => {
  return (
    <Suspense fallback={null}>
      <AboutLazy />
    </Suspense>
  );
};

export default About;
